export default __webpack_public_path__ + "static/media/mountain_hamster_1280.c733456a.webp";